<template>
  <div class="">
    <v-card outlined class="rounded-lg">
      <iframe
        class="pt-3"
        :height="$vuetify.breakpoint.mdAndUp ? '250px' : '550px'"
        width="100%"
        style="border: none"
        :src="urlGamification"
      ></iframe>
    </v-card>
  </div>
</template>

<script>
export default {
  props: ["urlGamification"],
};
</script>
